module.exports = __webpack_public_path__ + "img/ilya.021530d7.png";